export enum AcceptedFileType {
  All = '*',
  PDF = 'application/pdf',
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  WEBP = 'image/webp',
  HEIF = 'image/heif',
  HEIC = 'image/heic',
}
